import { z } from "zod";

const ACCEPTED_IMAGE_TYPES = ["jpeg", "jpg", "png", "webp"];
const ImgSchema = z.object({
  fileName: z.string(),
  name: z.string(),
  fileSize: z.number(),
  size: z.number(),
  key: z.string(),
});
export const IMG_MAX_LIMIT = 1;

export const actionSchema = z.object({
  title: z
    .string({ required_error: "Le titre est obligatoire" })
    .min(3, { message: "Le titre est obligatoire" }),
  date: z.date({
    required_error: "La date de début est obligatoire",
  }),
  description: z.string({ required_error: "La description est obligatoire" }),
  image: z
    .array(ImgSchema, { required_error: "L'image est obligatoire" })
    .max(IMG_MAX_LIMIT, {
      message: "Vous ne pouvez ajouter qu'une seule image.",
    })
    .min(1, { message: "Au moins une image doit être ajoutée." })
    .refine(
      (images) => {
        const invalidImages = images.filter((img) => {
          const fileExtension = img.fileName.split(".").pop()?.toLowerCase();
          return fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension);
        });
        return invalidImages.length === 0;
      },
      {
        message: "Le type de fichier de l'image n'est pas pris en charge.",
      }
    ),
});

export type ActionFormValues = z.infer<typeof actionSchema>;

export const updatedActionSchema = z
  .object({
    title: z
      .string()
      .min(3, { message: "Le titre doit comporter au moins 3 caractères." })
      .optional(),
    date: z
      .date({
        required_error: "La date est obligatoire",
      })
      .optional(),
    description: z
      .string({ required_error: "Description est obligatoire" })
      .optional(),
    image: z
      .array(ImgSchema)
      .max(IMG_MAX_LIMIT, {
        message: "Vous ne pouvez ajouter qu'une seule image.",
      })
      .min(1, { message: "Au moins une image doit être ajoutée." })
      .refine(
        (images) => {
          // Only validate if images are present
          if (images && images.length > 0) {
            const invalidImages = images.filter((img) => {
              const fileExtension = img.fileName
                .split(".")
                .pop()
                ?.toLowerCase();
              return (
                fileExtension && !ACCEPTED_IMAGE_TYPES.includes(fileExtension)
              );
            });
            return invalidImages.length === 0;
          }
          // If images is undefined or empty, don't apply any validation.
          return true;
        },
        {
          message: "Le type de fichier de l'image n'est pas pris en charge.",
        }
      )
      .optional(), // Allow image to be optional.
  })
  .partial(); // All fields are now optional

export type UpdatedActionSchema = z.infer<typeof updatedActionSchema>;
